import { ReactComponent as Svg } from "../assets/img/wavesmini.svg";
function Languages(){
    return(
        <>
           <section className="m-0 py-8 bg-white position-relative">
            <h3 className="text-center">Languages</h3>
            <div className="container mt-8">
                <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="row justify-content-start">
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="100" src="http://learn.bimash.com.np/assets/img/courses/1.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="500" src="http://learn.bimash.com.np/assets/img/courses/2.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="300" src="http://learn.bimash.com.np/assets/img/courses/3.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="400" src="http://learn.bimash.com.np/assets/img/courses/4.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="600" src="http://learn.bimash.com.np/assets/img/courses/5.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="700" src="http://learn.bimash.com.np/assets/img/courses/6.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="100" src="http://learn.bimash.com.np/assets/img/courses/7.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="100" src="http://learn.bimash.com.np/assets/img/courses/8.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="500" src="http://learn.bimash.com.np/assets/img/courses/9.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="100" src="http://learn.bimash.com.np/assets/img/courses/10.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="100" src="http://learn.bimash.com.np/assets/img/courses/11.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="800" src="http://learn.bimash.com.np/assets/img/courses/12.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="100" src="http://learn.bimash.com.np/assets/img/courses/13.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="200" src="http://learn.bimash.com.np/assets/img/courses/14.svg" alt="course title" />
                        <img className="col-2 p-4" data-aos="fade-in" data-aos-duration="100" src="http://learn.bimash.com.np/assets/img/courses/15.png" alt="course title" />
                    </div>
                    
                </div>
                <div className="col-lg-4 ms-auto">
                    <div className="card">
                    <img alt='' className="card-img-top" src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/soft-ui-design-system/assets/img/funny.jpg" />
                    <div className="position-relative overflow-hidden smallwaves" >
                        <div className="position-absolute w-100 top-0 z-index-1">
                            <Svg/>
                        </div>
                    </div>
                    <div className="card-body">
                        <h4>
                       L E A R N
                        </h4>
                        <p>
                            Videos provide greater engagement than text or images for the simple reason that it combines audio, video and text.
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </section>
</>
    )
}

export default Languages;